import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { useViewerRoles } from '@treams/treams-hooks';
import { Paragraph, StarsIcon, tokens } from '@treams/treams-ui';

export function AgentChatCostSummary(props: { estimatedCost?: number }) {
	const { t } = useTranslation();
	const { isWorkspaceSuperuser } = useViewerRoles();

	if (!isWorkspaceSuperuser || props.estimatedCost == null) {
		return null;
	}

	return (
		<Flex justifyContent="center" alignItems="center">
			<StarsIcon size={16} color={tokens.icon.secondary} />
			<Paragraph
				small
				mb={0}
				ml={`${tokens.gap.inline}px`}
				style={{ color: tokens.text.secondary }}
			>
				{t('aiAgent.estimatedChatCost', {
					cost: props.estimatedCost.toFixed(2),
				})}
			</Paragraph>
		</Flex>
	);
}
